import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AddAgentServ, getAgents } from "../../../Services/Agent";
import AddAgent from "../../Users/add-agent";
import { useTranslation } from "react-i18next";

const AssignTo: React.FunctionComponent<{ property: any, onchangeAgent: any, onChangeMessagehandler: any }> = (props) => {

    const [Agents, setAgents] = useState<any>([]);
    const [agentValue, setAgentValue] = useState<any>(props.property.agent || null);
    const [isChange, setIsChange] = useState<boolean>(false);
    const { t } = useTranslation();

    useEffect(() => {
        setAgentValue(props.property.agent || null);
        getAgents("").then((data) => {
            setAgents(data)
        }).catch((error: any) => {
            console.log("error")
        })
    }, [isChange]);

    // Agent 

    const handleSearchAgent = (event: any) => {
        console.log("agent", event.target.value)
        getAgents(event.target.value).then((data) => {
            setAgents(data)
        }).catch((error: any) => {
            console.log("error")
        })
    }

    const AddAgentHandler = (agent: any) => {
        return new Promise((resolve, reject) => {
            AddAgentServ(agent).then(resp => {
                setIsChange(!isChange)
                props.onChangeMessagehandler("success", "Agent added successfully !")
                resolve(resp);
            }).catch(error => {
                props.onChangeMessagehandler("error", error.response.data.error);
                reject(error);
            })
        });
    }

    const handleSelectChangeAgent = (newValue: any) => {
        console.log(newValue)
        setAgentValue(newValue)
        props.onchangeAgent(newValue)
    }

    return (
        <div className="row card-form mb-4">
            <div className="flex-agent">

                <h3 className="title-20 color-black  width-auto">
                      {t("propertyDetails.assignTo")}  
                </h3>

                <Autocomplete
                    freeSolo
                    value={agentValue}
                    onChange={(event, newValue) => {
                        if (newValue === null) {
                            setAgentValue("");
                            props.onchangeAgent(null);
                            return;
                        }
                        const selectedAgent = Agents.find((agent: any) =>
                            agent.fullName === newValue?.fullName
                        );
                        handleSelectChangeAgent(selectedAgent ? selectedAgent : "");
                    }}                    
                    className="input-property width-350 mb-3"
                    options={Agents}
                    getOptionLabel={(option) => option.fullName || ""}
                    noOptionsText={Agents.length === 0 ? "No agents found" : ""}
                    renderOption={(props, option) => (
                        <li {...props} key={option.id || option.email || option.fullName}>
                            <img
                                src={option.image}
                                alt={option.fullName}
                                style={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "50%",
                                    marginRight: 10,
                                    objectFit: "cover"
                                }}
                            />
                            {option.fullName}
                        </li>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            placeholder={t("propertyDetails.searchby")}
                            onChange={handleSearchAgent}
                        />
                    )}
                />

                <AddAgent onAddAgent={AddAgentHandler} />

            </div>
        </div>
    )
}

export default AssignTo;